export const configRadarDhJP = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHINT_JP_5min/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_JP_ICDB_Radar",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHINT_JP_5min_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarDhKR = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/KMA_OBS_RADAR/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_KR_ICDB_Radar",
      "url": "%expo_tile_gpv_url%/KMA_OBS_RADAR_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 8,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 121,
          "South": 30,
          "East": 133,
          "North": 41
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
}

export const configRadarDhTW = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/CWB_OBS_RADAR/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_TW_ICDB_Radar",
      "url": "%expo_tile_gpv_url%/CWB_OBS_RADAR_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 118,
          "South": 19,
          "East": 124,
          "North": 28
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
}

export const configRadarDhEchoTopJP = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHTOP_JP/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_RADAR_ECHTOP_JP",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHTOP_JP_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarJmaInfoDh = {
  "data": {
    "Type": "JSON",
    "Name": "JMA_INFO",
    "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_INFO/list",
    "retain": true,
    "cache_busting": true,
    "update_interval": 60
  }
}

export const configRadarDhXRAIN = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/MLIT_OBS_RADAR_PRCINT/list",
      "cache_busting": true
    },
    "region": {
      "Type":"JSON",
      "url": "%expo_tile_gpv_url%/MLIT_OBS_RADAR_PRCINT/region_area",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "MLIT_OBS_RADAR_PRCINT",
      "url": "%expo_tile_gpv_url%/MLIT_OBS_RADAR_PRCINT_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarDhNowCast = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "_url": "%expo_tile_gpv_url%/JMA_ANLSIS_PRCINT_HRES/list",
      "url": "%expo_tile_gpv_url%/JMA_NOWCAS_PRCINT_HRES/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_NOWCAS_PRCINT_HRES",
      "_url": "%expo_tile_gpv_url%/JMA_ANLSIS_PRCINT_HRES_%validtime%/%z%_%y%_%x%.png",
      "url": "%expo_tile_gpv_url%/JMA_NOWCAS_PRCINT_HRES_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarPrcintDh = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_PRCINT/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_RADAR_PRCINT",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_PRCINT_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configRadarPrcintEchoTopDh = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHTOP/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_RADAR_ECHTOP",
      "url": "%expo_tile_gpv_url%/JMA_OBS_RADAR_ECHTOP_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 3,
        "MaxZoom": 9,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120.5,
          "South": 21,
          "East": 149,
          "North": 46
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const expoRadarLayerConfig = {
  "Name": "XXX",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 1],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 255, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 144, 255, 120],
          [0, 0, 255, 120],
          [0, 0, 255, 120],
          [0, 0, 255, 120],
          [0, 0, 255, 120],
          [0, 0, 255, 120],
          [0, 0, 255, 120],
          [0, 0, 255, 120],
          [0, 0, 255, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [6, 207, 34, 120],
          [0, 255, 0, 120],
          [0, 255, 0, 120],
          [0, 255, 0, 120],
          [0, 255, 0, 120],
          [0, 255, 0, 120],
          [0, 255, 0, 120],
          [135, 255, 6, 120],
          [135, 255, 6, 120],
          [135, 255, 6, 120],
          [135, 255, 6, 120],
          [255, 255, 0, 120],
          [255, 255, 0, 120],
          [255, 255, 0, 120],
          [255, 255, 0, 120],
          [255, 255, 0, 120],
          [255, 255, 0, 120],
          [255, 255, 0, 120],
          [255, 255, 0, 120],
          [255, 191, 0, 120],
          [255, 191, 0, 120],
          [255, 191, 0, 120],
          [255, 191, 0, 120],
          [255, 191, 0, 120],
          [255, 191, 0, 120],
          [255, 191, 0, 120],
          [255, 191, 0, 120],
          [255, 165, 0, 120],
          [255, 165, 0, 120],
          [255, 165, 0, 120],
          [255, 165, 0, 120],
          [255, 165, 0, 120],
          [255, 165, 0, 120],
          [255, 165, 0, 120],
          [255, 165, 0, 120],
          [255, 140, 0, 120],
          [255, 140, 0, 120],
          [255, 140, 0, 120],
          [255, 140, 0, 120],
          [255, 140, 0, 120],
          [255, 140, 0, 120],
          [255, 140, 0, 120],
          [255, 140, 0, 120],
          [255, 21, 6, 120],
          [255, 21, 6, 120],
          [255, 21, 6, 120],
          [255, 21, 6, 120],
          [255, 21, 6, 120],
          [255, 21, 6, 120],
          [255, 21, 6, 120],
          [255, 21, 6, 120],
          [255, 0, 0, 120],
          [255, 0, 0, 120],
          [255, 0, 0, 120],
          [255, 0, 0, 120],
          [255, 0, 0, 120],
          [255, 0, 0, 120],
          [255, 0, 0, 120],
          [255, 0, 0, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [244, 0, 161, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [255, 0, 255, 120],
          [100, 100, 100, 30]
        ]
      }
    }
  }
};

export const configRadarLayerJP = {...expoRadarLayerConfig, Name: 'RadarJP'};
export const configRadarLayerKR = {...expoRadarLayerConfig, Name: 'RadarKR'};
export const configRadarLayerTW = {...expoRadarLayerConfig, Name: 'RadarTW'};
export const configRadarLayerXRAIN = {...expoRadarLayerConfig, Name: 'RadarXRAIN'};
export const configRadarLayerNowCast = {...expoRadarLayerConfig, Name: 'RadarNOWCAST'};
export const configRadarLayerPrcint = {...expoRadarLayerConfig, Name: 'RadarPrcint'};

export const configRadarLayerEchoTopJP = {
  "Name" : "EchoTop",
  "Renderer" : "ScreenGridValue",
  "Attributes": {
    "grid_size": 20,
    "font_size": 10,
    "color": "#844",
    "offset_x": 0,
    "offset_y": 5,
    "align": "center",
    "value_table": [
      "",
      "",
      "3",
      "10",
      "16",
      "23",
      "30",
      "36",
      "43",
      "49",
      "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""
    ]
  }
};

export const configRadarLayerPrcintEchoTop = {
  "Name" : "PrcintEchoTop",
  "Renderer" : "ScreenGridValue",
  "Attributes": {
    "grid_size": 20,
    "font_size": 10,
    "color": "#844",
    "offset_x": 0,
    "offset_y": 5,
    "align": "center",
    "value_table": [
      "",
      "",
      "3",
      "10",
      "16",
      "23",
      "30",
      "36",
      "43",
      "49",
      "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""
    ]
  }
};

export const expoRadarLayerCoverageConfig = {
  "Name": "XXX",
  "Renderer": "Image",
  "Attributes": {
    "layer_type" : "coverage",
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [128, 128, 128, 25],
        "palette": [
          [128, 128, 128, 25],
          [0, 0, 0, 1],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0]
        ]
      }
    }
  }
}

export const configRadarLayerCoverageJP = {...expoRadarLayerCoverageConfig, Name: 'RadarCoverageJP'};
export const configRadarLayerCoverageKR = {...expoRadarLayerCoverageConfig, Name: 'RadarCoverageKR'};
export const configRadarLayerCoverageTW = {...expoRadarLayerCoverageConfig, Name: 'RadarCoverageTW'};
export const configRadarLayerCoverageXRAIN = {...expoRadarLayerCoverageConfig, Name: 'RadarCoverageXRAIN'};
export const configRadarLayerCoverageNowCast = {...expoRadarLayerCoverageConfig, Name: 'RadarCoverageNOWCAST'};
export const configRadarLayerCoveragePrcint = {...expoRadarLayerCoverageConfig, Name: 'RadarCoveragePrcint'};
